<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Edit Personnel</h5>
    <form [formGroup]="EditNewPerson">

      <input type="hidden" formControlName="id" />

      <br>
      <br>
      <h4>Personnel List</h4>
      <br>

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Name (*)</label>
          <input formControlName="fname" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_fname().valid && get_Form_fname().touched"
            class="form-text text-muted MyErrorRedColor">Enter the first name.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Last Name (*)</label>
          <input formControlName="lname" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_lname().valid && get_Form_lname().touched"
            class="form-text text-muted MyErrorRedColor">Enter the last name.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> Gender </label>
          <select class="custom-select" formControlName="sex">
            <option value="0">Select</option>
            <option value="1">Male</option>
            <option value="2">Female</option>
          </select>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Marital Status</label>
          <select class="custom-select" formControlName="vaziat_Tahol">
            <option value="0">Select</option>
            <option value="1">Married</option>
            <option value="2">Single</option>
          </select>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Province </label>
          <select class="custom-select" formControlName="ProvinceId" (change)="ProvinceChange()">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_Province" [value]="item.code">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Place of Issue</label>
          <select class="custom-select" formControlName="mahal_tavalod">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_City" [value]="item.id">{{item.title}}</option>
          </select>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">ID Document Number</label>
          <input formControlName="shomareh_Shenasnameh" type="number" class="form-control"
            placeholder="Type here...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">ID Document Serial Number</label>
          <input formControlName="shomareh_Shenasnameh_Seri" type="text" class="form-control"
            placeholder="Type here...">
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">National ID (without leading zero)</label>
          <input formControlName="codeMeli" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_codeMeli().valid && get_Form_codeMeli().touched"
            class="form-text text-muted MyErrorRedColor">Enter the national ID.</small>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Insurance Number</label>
          <input formControlName="shomareh_bimeh" type="text" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Father</label>
          <input formControlName="name_Pedar" type="text" class="form-control" placeholder="Type here...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Father Occupation</label>
          <input formControlName="shoghleh_Pedar" type="text" class="form-control" placeholder="Type here...">
        </div>

      </div>

      <div class="row">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            Mobile Number (without leading zero)
            <button (click)="OnAdd_shomareh_Hamreh()" type="button"
              [disabled]="!get_Form_shomareh_Hamreh().valid || get_Form_shomareh_Hamreh().value =='' || get_Form_shomareh_Hamreh().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input formControlName="shomareh_Hamreh" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_shomareh_Hamreh().valid && get_Form_shomareh_Hamreh().touched"
            class="form-text text-muted MyErrorRedColor">Enter the mobile number.</small>
          <table class="mb-0 table table-bordered table-3 text-center table-striped"
            *ngIf="Person_shomareh_Hamreh_Array.length>0">
            <tr class="bg-warning" *ngFor="let item of Person_shomareh_Hamreh_Array">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="Person_shomareh_Hamreh_Delete(item.id)"><i
                    class="fa fa-remove"></i> Delete </a>
              </td>
            </tr>
          </table>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Housing </label>
          <select class="custom-select" formControlName="maskan">
            <option value="0">Select</option>
            <option value="1">Owned</option>
            <option value="2">Rented</option>
            <option value="3">Living with Relatives</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            Email
            <button (click)="OnAdd_email()" type="button"
              [disabled]="!get_Form_email().valid || get_Form_email().value =='' || get_Form_email().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input formControlName="email" type="email" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_email().valid && get_Form_email().touched"
            class="form-text text-muted MyErrorRedColor">Enter the email address.</small>
          <table class="mb-0 table table-bordered table-3 text-center table-striped"
            *ngIf="Person_email_Array.length>0">
            <tr class="bg-warning" *ngFor="let item of Person_email_Array">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="Person_email_Delete(item.id)"><i class="fa fa-remove"></i> Delete </a>
              </td>
            </tr>
          </table>
        </div>



      </div>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            Current Home Address
            <button (click)="OnAdd_address_Manzel()" type="button"
              [disabled]="!get_Form_address_Manzel().valid || get_Form_address_Manzel().value =='' || get_Form_address_Manzel().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input formControlName="address_Manzel" type="text" class="form-control" placeholder="Type here...">
          <table class="mb-0 table table-bordered table-3 text-center table-striped"
            *ngIf="Person_address_Manzel_Array.length>0">
            <tr class="bg-warning" *ngFor="let item of Person_address_Manzel_Array">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="Person_address_Manzel_Delete(item.id)"><i class="fa fa-remove"></i>
                  Delete </a>
              </td>
            </tr>
          </table>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            Postal Code
            <button (click)="OnAdd_codeposti()" type="button"
              [disabled]="!get_Form_codeposti().valid || get_Form_codeposti().value =='' || get_Form_codeposti().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input formControlName="codeposti" type="text" class="form-control" placeholder="Type here...">
          <table class="mb-0 table table-bordered table-3 text-center table-striped"
            *ngIf="Person_codeposti_Array.length>0">
            <tr class="bg-warning" *ngFor="let item of Person_codeposti_Array">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="Person_codeposti_Delete(item.id)"><i class="fa fa-remove"></i> Delete
                </a>
              </td>
            </tr>
          </table>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            Phone
            <button (click)="OnAdd_tel()" type="button"
              [disabled]="!get_Form_tel().valid || get_Form_tel().value =='' || get_Form_tel().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input formControlName="tel" type="number" class="form-control" placeholder="Type here...">
          <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_tel_Array.length>0">
            <tr class="bg-warning" *ngFor="let item of Person_tel_Array">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="Person_tel_Delete(item.id)"><i class="fa fa-remove"></i> Delete </a>
              </td>
            </tr>
          </table>
        </div>

      </div>

      <div class="row" [hidden]="get_Form_Sex().value!='1'">

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Military Service Status</label>
          <select class="custom-select" formControlName="vaziat_Nazam_Vazifeh">
            <option value="0">Select</option>
            <option value="1">Completed</option>
            <option value="2">Temporary Exemption</option>
            <option value="3">Permanent Exemption</option>
          </select>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Military Service Status Description</label>
          <input formControlName="vaziat_Nazam_Vazifeh_Dsc" type="text" class="form-control"
            placeholder="Type here...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">From Date </label>
          <input formControlName="vaziat_startDate" #vaziat_startDateInput type="text" class="form-control"
            placeholder="Type here...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_startDateInput"></ng-persian-datepicker>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">To Date </label>
          <input formControlName="vaziat_endDate" #vaziat_endDateInput type="text" class="form-control"
            placeholder="Type here...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_endDateInput"></ng-persian-datepicker>
        </div>

      </div>

      <div class="row" [hidden]="get_Form_vaziat_Tahol().value!='1'">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Spouse Name</label>
          <input formControlName="name_Hamsar" type="text" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Number of Children</label>
          <input formControlName="tedadFarzandan" type="number" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Spouse National ID (without leading zero) </label>
          <input formControlName="codeMeli_Hamsar" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_codeMeli_Hamsar().valid && get_Form_codeMeli_Hamsar().touched"
            class="form-text text-muted MyErrorRedColor">Enter the spouse national ID.</small>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            Spouse Mobile Number (without leading zero)
            <button (click)="OnAdd_shomareh_hamrah_Hamsar()" type="button"
              [disabled]="!get_Form_shomareh_hamrah_Hamsar().valid || get_Form_shomareh_hamrah_Hamsar().value =='' || get_Form_shomareh_hamrah_Hamsar().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input formControlName="shomareh_hamrah_Hamsar" type="number" class="form-control"
            placeholder="Type here...">
          <small *ngIf="!get_Form_shomareh_hamrah_Hamsar().valid && get_Form_shomareh_hamrah_Hamsar().touched"
            class="form-text text-muted MyErrorRedColor">Enter the spouse mobile number.</small>
          <table class="mb-0 table table-bordered table-3 text-center table-striped"
            *ngIf="Person_shomareh_hamrah_Hamsar_Array.length>0">
            <tr class="bg-warning" *ngFor="let item of Person_shomareh_hamrah_Hamsar_Array">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="Person_shomareh_hamrah_Hamsar_Delete(item.id)"><i
                    class="fa fa-remove"></i> Delete </a>
              </td>
            </tr>
          </table>
        </div>

      </div>

      <div class="row" [hidden]="get_Form_vaziat_Tahol().value!='1'">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Spouse Education</label>
          <select class="custom-select" formControlName="tahsilat_Hamsar">
            <option value="0">Select</option>
            <option value="1">Middle School</option>
            <option value="2">High School Diploma</option>
            <option value="3">Associate Degree</option>
            <option value="4">Bachelor's Degree</option>
            <option value="5">Master's Degree</option>
            <option value="6">Doctorate</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Spouse Date of Birth</label>
          <input formControlName="tarikh_Tavalod_Hamsar" #tarikh_Tavalod_HamsarInput type="text" class="form-control"
            placeholder="Type here...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="tarikh_Tavalod_HamsarInput"></ng-persian-datepicker>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Spouse Occupation</label>
          <input formControlName="shoghleh_Hamsar" type="text" class="form-control" placeholder="Type here...">
        </div>

      </div>

      <div class="row" >
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Date of Birth </label>
          <input formControlName="tarikh_Tavalod" #tarikh_Tavalod_Input type="text" class="form-control"  placeholder="Type here...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="tarikh_Tavalod_Input"></ng-persian-datepicker>
        </div>
      </div>

      <br>
      <br>
      <hr>
      <br>
      <h4>Upload Documents</h4>
      <br>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            National ID Card 1
            <button (click)="Remove_uploadcodemeli_Image1()" type="button" *ngIf="Edit_Record_Persone.codemeli_Image1"
              class="btn  btn-danger"><i class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_codemeli_Image1" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_codemeli_Image1" #file_codemeli_Image1
            (change)="uploadcodemeli_Image1(file_codemeli_Image1.files)" type="file" class="form-control"
            placeholder="Type here...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.codemeli_Image1)"
            *ngIf="Edit_Record_Persone.codemeli_Image1" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.codemeli_Image1}}" />
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            National ID Card 2
            <button (click)="Remove_uploadcodemeli_Image2()" type="button" *ngIf="Edit_Record_Persone.codemeli_Image2"
              class="btn  btn-danger"><i class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_codemeli_Image2" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_codemeli_Image2" #file_codemeli_Image2
            (change)="uploadcodemeli_Image2(file_codemeli_Image2.files)" type="file" class="form-control"
            placeholder="Type here...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.codemeli_Image2)"
            *ngIf="Edit_Record_Persone.codemeli_Image2" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.codemeli_Image2}}" />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            ID Document 1
            <button (click)="Remove_uploadshenasNameh_Image1()" type="button"
              *ngIf="Edit_Record_Persone.shenasNameh_Image1" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_shenasNameh_Image1" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_shenasNameh_Image1" #file_shenasNameh_Image1
            (change)="uploadshenasNameh_Image1(file_shenasNameh_Image1.files)" type="file" class="form-control"
            placeholder="Type here...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.shenasNameh_Image1)"
            *ngIf="Edit_Record_Persone.shenasNameh_Image1" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.shenasNameh_Image1}}" />
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            ID Document 2
            <button (click)="Remove_uploadshenasNameh_Image2()" type="button"
              *ngIf="Edit_Record_Persone.shenasNameh_Image2" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_shenasNameh_Image2" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_shenasNameh_Image2" #file_shenasNameh_Image2
            (change)="uploadshenasNameh_Image2(file_shenasNameh_Image2.files)" type="file" class="form-control"
            placeholder="Type here...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.shenasNameh_Image2)"
            *ngIf="Edit_Record_Persone.shenasNameh_Image2" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.shenasNameh_Image2}}" />
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            ID Document 3
            <button (click)="Remove_uploadshenasNameh_Image3()" type="button"
              *ngIf="Edit_Record_Persone.shenasNameh_Image3" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_shenasNameh_Image3" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_shenasNameh_Image3" #file_shenasNameh_Image3
            (change)="uploadshenasNameh_Image3(file_shenasNameh_Image3.files)" type="file" class="form-control"
            placeholder="Type here...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.shenasNameh_Image3)"
            *ngIf="Edit_Record_Persone.shenasNameh_Image3" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.shenasNameh_Image3}}" />
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            Military Service Completion Card
            <button (click)="Remove_uploadkartPayan_Khadamt_Image()" type="button"
              *ngIf="Edit_Record_Persone.kartPayan_Khadamt_Image" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_kartPayan_Khadamt_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_kartPayan_Khadamt_Image" #file_kartPayan_Khadamt_Image
            (change)="uploadkartPayan_Khadamt_Image(file_kartPayan_Khadamt_Image.files)" type="file"
            class="form-control" placeholder="Type here...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.kartPayan_Khadamt_Image)"
            *ngIf="Edit_Record_Persone.kartPayan_Khadamt_Image" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.kartPayan_Khadamt_Image}}" />
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            Criminal Record Form
            <button (click)="Remove_uploadform_soe_Pishineh_Image()" type="button"
              *ngIf="Edit_Record_Persone.form_soe_Pishineh_Image" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_form_soe_Pishineh_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_form_soe_Pishineh_Image" #file_form_soe_Pishineh_Image
            (change)="uploadform_soe_Pishineh_Image(file_form_soe_Pishineh_Image.files)" type="file"
            class="form-control" placeholder="Type here...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.form_soe_Pishineh_Image)"
            *ngIf="Edit_Record_Persone.form_soe_Pishineh_Image" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.form_soe_Pishineh_Image}}" />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            Personnel Photo
            <button (click)="Remove_uploadax_Personeli_Image()" type="button"
              *ngIf="Edit_Record_Persone.ax_Personeli_Image" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_ax_Personeli_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_ax_Personeli_Image" #file_ax_Personeli_Image
            (change)="uploadax_Personeli_Image(file_ax_Personeli_Image.files)" type="file" class="form-control"
            placeholder="Type here...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.ax_Personeli_Image)"
            *ngIf="Edit_Record_Persone.ax_Personeli_Image" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.ax_Personeli_Image}}" />
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            Personnel Photo 2
            <button (click)="Remove_uploadax_Personeli_Image2()" type="button"
              *ngIf="Edit_Record_Persone.ax_Personeli_Image2" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_ax_Personeli_Image2" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_ax_Personeli_Image2" #file_ax_Personeli_Image2
            (change)="uploadax_Personeli_Image2(file_ax_Personeli_Image2.files)" type="file" class="form-control"
            placeholder="Type here...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.ax_Personeli_Image2)"
            *ngIf="Edit_Record_Persone.ax_Personeli_Image2" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.ax_Personeli_Image2}}" />
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            Signature
            <button (click)="Remove_uploadax_Sign_Image()" type="button" *ngIf="Edit_Record_Persone.sign_image"
              class="btn  btn-danger"><i class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_ax_Sign_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_ax_Sign_Image" #file_ax_Sign_Image
            (change)="uploadax_Sign_Image(file_ax_Sign_Image.files)" type="file" class="form-control"
            placeholder="Type here...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.sign_image)" *ngIf="Edit_Record_Persone.sign_image"
            style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.sign_image}}" />
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            Interview Resume Form
            <button (click)="Remove_uploadform_reserve_mosahebeh_Image()" type="button"
              *ngIf="Edit_Record_Persone.form_reserve_mosahebeh_Image" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_form_reserve_mosahebeh_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_form_reserve_mosahebeh_Image" #file_form_reserve_mosahebeh_Image
            (change)="uploadform_reserve_mosahebeh_Image(file_form_reserve_mosahebeh_Image.files)" type="file"
            class="form-control" placeholder="Type here...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.form_reserve_mosahebeh_Image)"
            *ngIf="Edit_Record_Persone.form_reserve_mosahebeh_Image" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.form_reserve_mosahebeh_Image}}" />
        </div>
      </div>

      <br>
      <br>
      <hr>
      <br>
      <h4>Position at Behineh Farayand Azma</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Behineh Employment Date (*)</label>
          <input formControlName="tarikh_Eshtekhdam" #tarikh_EshtekhdamInput type="text" class="form-control"
            placeholder="Type here...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="tarikh_EshtekhdamInput"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Abbreviation in Behineh Farayand Azma (*) </label>
          <input formControlName="almat_Ekhtesari" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_almat_Ekhtesari().valid && get_Form_almat_Ekhtesari().touched"
            class="form-text text-muted MyErrorRedColor">Enter the abbreviation in Behineh Farayand Azma.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Previous Experience before Behfa (Years)</label>
          <input formControlName="sabegh" type="number" class="form-control"  placeholder="Type here...">
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Activity Location</label>
          <select class="custom-select" formControlName="field_activity_id">
            <option value="0">Select</option>
            <option value="1">Inside the Laboratory</option>
            <option value="2">Outside the Laboratory</option>
            <option value="3">Inside/Outside the Laboratory</option>
            <option value="4">Administrative</option>
            <option value="5">Financial</option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Position</label>
          <select class="custom-select" formControlName="semat_id">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_Semat" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
      </div>



    </form>



    <br>
    <br>

    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" type="button" (click)="SubmitEditNewPerson()" [disabled]="!EditNewPerson.valid"
      class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
    <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i
        class="fa fa-times-rectangle"></i> Cancel </button>
    <button routerLink="/Person" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i> Back </button>
  </div>
</div>


<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> View Image </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Person/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Person/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> Download </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">Close</button>
  </div>
</ng-template>
